import { HttpErrorResponse } from '@node_modules/@angular/common/http';
import { throwError } from '@node_modules/rxjs';
import { Injector } from '@angular/core';
import { ENVIRONMENT, Environment } from '@shared/utils/environment';

export class BaseService {
    public readonly environment: Environment;
    constructor(protected readonly injector: Injector) {
        this.environment = this.injector.get(ENVIRONMENT);
    }

    protected handleError(errorResponse: HttpErrorResponse) {
        console.error(`Backend returned code ${errorResponse.status}, body was: `, errorResponse.error);
        switch (errorResponse.status) {
            case 403:
                abp.notify.error('You are not authorized to perform this action.', 'Unauthorized');
                break;
            case 404:
                abp.message.error('Resource not found.');
                break;
            case 500:
                abp.message.error('Internal Server Error.');
                break;
            default:
                let errorMessage = '';

                // Check if the error response has a result property with a message
                if (errorResponse.error.result && typeof errorResponse.error.result === 'string') {
                    errorMessage = errorResponse.error.result;
                }
                // Check if the error response has a result property with an innerException property
                if (errorResponse.error.result?.innerException) {
                    errorMessage = errorResponse.error.result.innerException.Message;
                }
                // Check if the error response has a result property with a message property
                if (errorResponse.error.result?.message) {
                    errorMessage = errorResponse.error.result.message;
                }
                // Check if the error response has an error property with a message property
                if (errorResponse.error.message) {
                    errorMessage = errorResponse.error.message;
                }

                if (errorResponse.error) {
                    errorMessage = errorResponse.error;
                }

                abp.message.error(errorMessage, 'An error occurred.');
                break;
        }

        // Return an observable with a user-facing error message.
        return throwError(() => new Error('Something bad happened; please try again later.'));
    }
}
